import { createApp } from 'vue'
import App from './App.vue'
import '@/App.css' 
import router from './router';
import './assets/tailwind.css';
import PrimeVue from "primevue/config";
import 'primeicons/primeicons.css'
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import { getLocale } from './composables/locales';
import Tooltip from 'primevue/tooltip';
import SecurityManager from './SecurityManager';
import { createPinia } from 'pinia';
import 'emoji-picker-element';
import { sleep } from './composables/sleep';
import { createGtag } from 'vue-gtag'
import { env } from './composables/config';

const securityManager = new SecurityManager();
if (securityManager.mustRaiseSecurity()) {
    securityManager.raiseMaxSecurity();
}

async function bootstrap() {
    const app = createApp(App);
    app.use(PrimeVue, {
        theme: {
            preset: Aura
        },
        locale: getLocale('ptBr')
    });
    app.directive('tooltip', Tooltip);
    app.use(ToastService);

    const pinia = createPinia();
    app.use(pinia);
    
    app.use(router);
    app.use(
        createGtag({
            config: { 
                id: env('APP_GTAG_ID') 
            },
            bootstrap: false
        }, router)
    );


    await sleep(50);

    app.mount('#app');
}

bootstrap();